import { Box, CircularProgress, Typography } from "@mui/material";

import ChoicePills from "./ChoicePills";
import StepBlock from "./StepBlock";

const SCOPE_OPTIONS = [
  { value: "organization", label: "本校" },
  { value: "grade", label: "年級" },
  { value: "grp", label: "社" },
];

const GRADES = ["1", "2", "3", "4", "5", "6", "7"];

export default function ScopeSelection({
  scope,
  scopeArg,
  groups,
  groupsLoading,
  onChange,
  readOnly = false,
}) {
  const grade = scope === "grade" ? scopeArg : "";
  const groupName = scope === "grp" ? scopeArg : "";
  const scopeOptions =
    scope === "steminpe" ? [{ value: "steminpe", label: "校際" }, ...SCOPE_OPTIONS] : SCOPE_OPTIONS;
  let groupOptions = (groups || [])
    .filter((group) => {
      const name = String(group?.name_zh || "").trim();
      return name !== "" && !name.includes("/");
    })
    .map((group) => ({
      value: group.name_zh,
      label: group.name_zh,
    }));
  if (readOnly && groupName && !groupOptions.some((option) => option.value === groupName)) {
    groupOptions = [{ value: groupName, label: groupName }, ...groupOptions];
  }

  const selectScope = (nextScope) => {
    if (readOnly) {
      return;
    }
    if (nextScope === "organization") {
      onChange({ scope: "organization", scopeArg: "_" });
      return;
    }
    if (nextScope === scope) {
      return;
    }
    onChange({ scope: nextScope, scopeArg: "" });
  };

  return (
    <StepBlock number="1" title="排名範圍" subtitle="誰可以進入排名">
      <ChoicePills
        options={scopeOptions}
        value={scope}
        onChange={selectScope}
        tone="soft"
        disabled={readOnly}
      />

      {scope === "grade" ? (
        <Box sx={{ mt: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
            <Typography variant="body2" sx={{ color: "#6b7280" }}>
              選擇級別（本校內）
            </Typography>
            <ChoicePills
              options={GRADES.map((item) => ({ value: item, label: item }))}
              value={grade}
              
              onChange={(nextGrade) => {
                // if (readOnly) {
                //   return;
                // }
                onChange({ scope: "grade", scopeArg: nextGrade });
              }}
            />
            <Typography variant="body2" sx={{ color: "#6b7280" }}>
              {grade ? `包括 ${grade}A、${grade}B...` : "包括 1A、1B..."}
            </Typography>
          </Box>
        </Box>
      ) : null}

      {scope === "grp" ? (
        <Box sx={{ mt: 1.5 }}>
          <Typography variant="body2" sx={{ color: "#6b7280", mb: 1 }}>
            選擇社（本校內）
          </Typography>
          {groupsLoading ? <CircularProgress size={18} /> : null}
          {!groupsLoading && groupOptions.length === 0 ? (
            <Typography variant="body2" sx={{ color: "#6b7280" }}>
              尚未建立社
            </Typography>
          ) : null}
          {groupOptions.length > 0 ? (
            <ChoicePills
              options={groupOptions}
              value={groupName}
              // disabled={readOnly}
              onChange={(nextGroup) => {
                // if (readOnly) {
                //   return;
                // }
                onChange({ scope: "grp", scopeArg: nextGroup });
              }}
            />
          ) : null}
        </Box>
      ) : null}
    </StepBlock>
  );
}
